import styled from 'styled-components';
import breakpoints from 'app/shared/components/LandingPageRefresh/breakpoints';

export const Background = styled.div`
    background-color: black;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 300;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    @media ${breakpoints.medium} {
        background-color: rgba(0,0,0,0.7);
    }
`;
